import React from "react";
import { Button, Col, Row } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "configs/FirebaseConfig";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";
import TotpSetup from "./TotpSetup";

const TotpSetupWrapper = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate(AUTH_PREFIX_PATH);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", backgroundColor: "#f0f2f5" }}>
      <Row justify="center" style={{ width: "100%" }}>
        <Col xs={24} sm={22} md={18} lg={14} xl={12}>
          <TotpSetup />
          <div style={{ textAlign: "center", marginTop: "16px" }}>
            <Button icon={<LogoutOutlined />} onClick={handleLogout}>
              {t("cancel_mfa_setup")}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TotpSetupWrapper;
